import { createEvent, createStore, restore, sample } from 'effector'
import {
  NotificationPayload,
  showNotification,
} from 'src/features/notifications'
import { fx } from 'src/libs'
import {
  WebSiteItem,
  WebSitePayload,
  WebSiteRequest,
  WebSiteResponse,
} from 'src/pages/ib/adMaterials/webSitePages/types'

export const BASE_URL = '/partner/material/website'

export const onChangeWebSiteList = createEvent<WebSiteRequest>()
export const loadWebSiteById = createEvent<{ id: string }>()

export const getWebSiteListFx = fx<WebSiteRequest, WebSiteResponse>({
  method: 'GET',
  url: BASE_URL,
})

export const getWebSiteByIdFx = fx<{ id: string }, WebSiteItem>({
  method: 'GET',
})

export const createWebSiteFx = fx<WebSitePayload, WebSitePayload>({
  method: 'POST',
  url: BASE_URL,
})

export const updateWebSiteFx = fx<WebSitePayload, WebSitePayload>({
  method: 'PUT',
})

export const $webSiteList = createStore<WebSiteItem[]>([]).on(
  getWebSiteListFx.doneData,
  (_, res) => res.body.items,
)

export const $totalCountOfWebSiteList = restore(
  getWebSiteListFx.doneData.map((a) => a.body.total),
  0,
)

export const $webSiteCurrent = createStore<WebSiteItem | null>(null).on(
  getWebSiteByIdFx.doneData,
  (_, res) => res.body,
)

sample({
  clock: onChangeWebSiteList,
  fn: ({ limit, page }) => {
    return {
      query: {
        limit: String(limit),
        page: String(page),
      },
    }
  },
  target: getWebSiteListFx,
})

sample({
  clock: loadWebSiteById,
  fn: ({ id }) => ({ url: `${BASE_URL}/${id}` }),
  target: getWebSiteByIdFx,
})

sample({
  clock: [
    getWebSiteListFx.failData,
    createWebSiteFx.failData,
    updateWebSiteFx.failData,
  ],
  fn: (error): NotificationPayload => ({
    type: 'error',
    message: 'Request failed',
    description: error?.body?.message ?? 'Request failed',
  }),
  target: showNotification,
})

sample({
  clock: createWebSiteFx.doneData,
  fn: (params): NotificationPayload => {
    const name = params?.body?.title ?? ''
    return {
      type: 'success',
      message: 'Request success',
      description: `Website page link ${name} added successfully`,
    }
  },
  target: showNotification,
})

sample({
  clock: updateWebSiteFx.doneData,
  fn: (params): NotificationPayload => {
    const name = params?.body?.title ?? ''
    return {
      type: 'success',
      message: 'Request success',
      description: `Website page link${name} updated successfully`,
    }
  },
  target: showNotification,
})
